// @flow
import React from 'react';
import type { Element } from 'react';
import Grid from 'styled-components-grid';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { pr, px } from 'styled-components-spacing';

import ButtonSecondary from '@components/ButtonSecondary';
import { useTranslation } from '@i18n';
import type { I18n } from '@globalTypes';
import {
  FootFacebook,
  FootInsta,
  FootWhatsapp,
  FootTwitter,
  FootLinkedin
} from '@images/svg/index';
import type { PropsFooterBottom } from './types';

import { StyledCopyrightInfo, StyledGrid, StyledGridUnit } from './styles';

const IconList = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const IconItem = styled.li`
  font-size: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${px(2)}
  & > a > svg {
    width: 48px;
  }
  ${breakpoint('desktop')`
    ${pr(1)}
  `}

  @media(max-width: 320px){
    font-size: 28px;

    & > a > svg {
      width: 32px;
    }
  }
  & > a > svg > circle{
     fill:${props => (props.curefyDomain ? 'rgb(229, 245, 234)' : '')}
    }
  svg,
  path {
    fill: ${props => (props.curefyDomain ? 'rgb(1, 57, 57)' : '')};
  }
`;

export const getLanguageButton = (
  i18n: I18n,
  Router: {
    findAndGetUrls: (
      routeName: string,
      locale: string,
      params: {}
    ) => { route: string, urls: { as: string } }
  },
  router: {
    query: {
      nextRoute: string
    }
  }
): Element<any> => {
  const newLanguageLabel = i18n.language === 'en' ? 'Deutsch' : 'English';

  const onClick = () => {
    // eslint-disable-next-line no-unused-vars
    const { nextRoute, ...params } = router.query;
    // window.open(routes.findAndGetUrls(nextRoute, '', params).urls.as, '_self');
  };

  return (
    <ButtonSecondary rel="nofollow" size="LARGE" onClick={onClick}>
      {newLanguageLabel}
    </ButtonSecondary>
  );
};
const FooterBottom = ({ curefyDomain }: PropsFooterBottom): Element<any> => {
  const { t } = useTranslation(['Footer']);

  return (
    <StyledGrid reverse={{ mobile: true, desktop: false }} curefyDomain={curefyDomain}>
      <StyledGridUnit visible={{ mobile: false, desktop: true }} size={1}>
        {/* <FooterYapitaLogo /> */}
        <StyledCopyrightInfo curefyDomain={curefyDomain}>
          <> © 2020 Yapita Health, Gurugram, Haryana, India.</>
          {t('Copyright')}
        </StyledCopyrightInfo>
      </StyledGridUnit>
      <StyledGridUnit visible={{ mobile: false, desktop: true }} size={1}>
        <IconList>
          <IconItem curefyDomain={curefyDomain}>
            <a href={curefyDomain ? 'https://www.facebook.com/curefydotAi' : 'https://www.facebook.com/yapitahealth/'}>
              <FootFacebook alt={curefyDomain ? 'Facebook - Curefy' : 'Facebook - YapitaHealth'} />
            </a>
          </IconItem>
          <IconItem curefyDomain={curefyDomain}>
            <a href={curefyDomain ? 'https://www.instagram.com/curefy.ai/' : 'https://www.instagram.com/yapitahealth/'}>
              <FootInsta alt={curefyDomain ? 'Instagram - Curefy' : 'Instagram - Yapita Health'} />
            </a>
          </IconItem>
          <IconItem curefyDomain={curefyDomain}>
            <a href={curefyDomain ? 'https://x.com/CurefyAi' : 'https://x.com/yapitahealth'}>
              <FootTwitter alt={curefyDomain ? 'Twitter - Curefy' : 'Twitter - Yapita Health'} />
            </a>
          </IconItem>
          <IconItem curefyDomain={curefyDomain}>
            <a href={curefyDomain ? 'https://www.linkedin.com/showcase/curefy-ai/' : 'https://www.linkedin.com/company/yapitahealth'}>
              <FootLinkedin alt={curefyDomain ? 'LinkedIn - Curefy' : 'LinkedIn - Yapita Health'} />
            </a>
          </IconItem>
          <IconItem curefyDomain={curefyDomain}>
            <a
              href={curefyDomain ? 'https://api.whatsapp.com/send?phone=919599818171&text=Hello%20Curefy.%20I%20need%20medical%20assistance%20for:' : 'https://api.whatsapp.com/send?phone=919599818171&text=Hello%20Yapita%20Health.%20I%20need%20medical%20assistance%20for:'}
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
            >
              <FootWhatsapp alt={curefyDomain ? 'Whatsapp - Curefy' : 'Whatsapp - Yapita Health'} />
            </a>
          </IconItem>
        </IconList>
      </StyledGridUnit>

      <Grid.Unit size={{ mobile: 1, desktop: 3 / 12 }} />
    </StyledGrid>
  );
};

export default FooterBottom;
